/**
 * Buy Tickets Frontend Handler
 * Handles multiple purchase buttons
 */

document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('.xtra-buy-newsbytes__button');
    
    buttons.forEach(button => {
        button.addEventListener('click', async (e) => {
            e.preventDefault();

            // Check if user is logged in
            if (!xtraStripeBuyNewsBytes.isLoggedIn) {
                // Redirect to login page
                window.location.href = xtraStripeBuyNewsBytes.loginUrl;
                return;
            }

            // Find the shared message div for all buttons
            const optionsContainer = button.closest('.xtra-buy-newsbytes__options');
            const messageDiv = optionsContainer.querySelector('.xtra-buy-newsbytes__message');
            const originalText = button.textContent;
            
            // Show loading state
            button.disabled = true;
            button.textContent = 'Loading...';
            messageDiv.style.display = 'none';
            messageDiv.className = 'xtra-buy-newsbytes__message';
            
            // Get button data
            const priceId = button.dataset.priceId;
            const quantity = parseInt(button.dataset.quantity || '1');
            const successUrl = button.dataset.successUrl || window.location.href;
            const cancelUrl = button.dataset.cancelUrl || window.location.href;
            
            try {
                // Make request to create checkout session
                const response = await fetch(xtraStripeBuyNewsBytes.apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-WP-Nonce': xtraStripeBuyNewsBytes.nonce
                    },
                    body: JSON.stringify({
                        price_id: priceId,
                        quantity: quantity,
                        mode: 'payment',
                        success_url: successUrl,
                        cancel_url: cancelUrl
                    })
                });
                
                const data = await response.json();
                
                if (response.ok && data.url) {
                    // Redirect to Stripe checkout
                    window.location.href = data.url;
                } else {
                    // Show error message
                    const errorMessage = data.message || 'Failed to create checkout session. Please try again.';
                    messageDiv.textContent = errorMessage;
                    messageDiv.className = 'xtra-buy-newsbytes__message error';
                    messageDiv.style.display = 'block';
                    
                    // Reset button
                    button.disabled = false;
                    button.textContent = originalText;
                }
            } catch (error) {
                // Show network error
                messageDiv.textContent = 'Network error. Please check your connection and try again.';
                messageDiv.className = 'xtra-buy-newsbytes__message error';
                messageDiv.style.display = 'block';
                
                // Reset button
                button.disabled = false;
                button.textContent = originalText;
            }
        });
    });
});